export const baseurl = "https://stxavierspune.edu.in/";
// export const baseurl = "http://localhost:3000/";

// http://localhost:3000/
// https://stxavierspune.edu.in/
